import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OAuth from './OAuth';

function GoogleBox() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="google-box u-margin-top-xxl">
      <OAuth />

      <div className="google-box__bottom">
        {location.pathname === '/login' ? (
          <>
            <button
              className="btn btn__form u-margin-bottom-xl"
              onClick={() => {
                navigate('/forgot-password');
              }}
            >
              Forgot Password?
            </button>

            <button
              className="btn btn__form"
              onClick={() => {
                navigate('/register');
              }}
            >
              Register
            </button>
          </>
        ) : (
          <button
            className="btn btn__form"
            onClick={() => {
              navigate('/login');
            }}
          >
            Log In
          </button>
        )}
      </div>
    </div>
  );
}

export default GoogleBox;
